export default __webpack_public_path__ + "static/media/Linkedin-icon.912b2e7f.svg";